window. bzSubmitAjaxOptin = (f, url, lyr_id) => {
	if(!bzOptinValidate(f)) { return false; }

	url = url + '?' + bzNoCache();

	bzAjaxRequest(url, lyr_id, f.id);
}

window. bzSubmitOptin = (f) => {
	if(!bzOptinValidate(f)) { return false; }
	f.submit();
}

window. bzOptinValidate = (f) => {
	if(f._bzrflds.value!='') {
        let res = f._bzrflds.value.split(',');

		if(bzIndexOf(res,'first_name')!==-1) {
			if(f.first_name.value==='') { alert('Please fill in your first name.'); return false; }
		}
	}

	if (f.email.value==='') { alert('Please fill in your email address.'); return false; }
	return true;
}
